const debounceMap = new Map();

export const debounceAsync = (key, fn, delay = 500) => {
  if (debounceMap.has(key)) {
    clearTimeout(debounceMap.get(key));
  }

  return new Promise((resolve) => {
    const timer = setTimeout(async () => {
      const result = await fn();
      resolve(result);
      debounceMap.delete(key);
    }, delay);

    debounceMap.set(key, timer);
  });
};